export default function videoWidget() {
  const widgetName = 'videoWidget';
  const widgetOpts = videoWidgetOpts;

  $(`#${widgetName}`).append('<iframe></iframe>');
  $(`#${widgetName}`).wrap('<div id="videoSection"></div>');
  $('#videoSection').prepend('<div class="video-overlay-text">watch</div>');

  $(`#${widgetName}`).videoWidget({
    scriptPath: widgetOpts.scriptPath,
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    detectIpad: IPADDETECTED,
    multiVideo: false,
    showOnMobile: true,
    maxVideos: 1,
    autoPlayVideo: false,
    loopVideo: false,
    showControls: true,

    videoWidgetLoaded: function (data) {
      const videoCount = data.Slides.length > 0;

      if (videoCount) {
        $('.tier-three').css('opacity', '1');
      } else {
        $('.tier-three').remove();
        $('#videoSection').remove();
      }
    },
  });
}
